import { useEffect, useState } from "react";
import { LOGOS, CONTACT_INFO, api } from "../lib/api";
import { MapPin, Phone, Mail, Facebook, Instagram } from "lucide-react";

export default function Footer() {
  const [affs, setAffs] = useState([]);
  useEffect(() => {
    api.get("/affiliations").then((r) => setAffs(r.data)).catch(() => {});
  }, []);

  return (
    <footer className="bg-[#0f1f17] text-stone-200 mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5 flex gap-5 items-start">
            <img
              src={LOGOS.footer}
              alt="EDSW Foundation Seal"
              className="w-24 h-24 object-contain bg-white rounded-full p-2 shrink-0"
              data-testid="footer-logo"
            />
            <div>
              <h3 className="font-serif-display text-3xl text-white leading-tight">
                EDSW Foundation
              </h3>
              <p className="text-sm text-stone-400 mt-2 max-w-xs leading-relaxed">
                Education and Development Social Welfare Foundation — empowering
                communities through education since 2009.
              </p>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="overline text-[#F4A261] mb-4">Explore</div>
            <ul className="space-y-2 text-sm">
              <li><a href="/" className="hover:text-[#F4A261] transition-colors">Home</a></li>
              <li><a href="/#courses" className="hover:text-[#F4A261] transition-colors">Courses</a></li>
              <li><a href="/#verify" className="hover:text-[#F4A261] transition-colors">Verify Certificate</a></li>
              <li><a href="/#mission" className="hover:text-[#F4A261] transition-colors">Our Words</a></li>
              <li><a href="/#contact" className="hover:text-[#F4A261] transition-colors">Contact</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="overline text-[#F4A261] mb-4">Reach Us</div>
            <ul className="space-y-3 text-sm">
              <li className="flex gap-3 items-start">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-[#F4A261]" />
                <span>{CONTACT_INFO.address}</span>
              </li>
              <li className="flex gap-3 items-center">
                <Phone className="w-4 h-4 shrink-0 text-[#F4A261]" />
                <a href={`tel:${CONTACT_INFO.phone}`} className="hover:text-[#F4A261]">{CONTACT_INFO.phone}</a>
              </li>
              <li className="flex gap-3 items-center">
                <Mail className="w-4 h-4 shrink-0 text-[#F4A261]" />
                <a href={`mailto:${CONTACT_INFO.email}`} className="hover:text-[#F4A261] break-all">{CONTACT_INFO.email}</a>
              </li>
            </ul>
            <div className="flex gap-3 mt-5">
              <a href="#" className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#F4A261] hover:text-[#0f1f17] flex items-center justify-center transition-colors" aria-label="Facebook">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#F4A261] hover:text-[#0f1f17] flex items-center justify-center transition-colors" aria-label="Instagram">
                <Instagram className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-stone-400">
          <p>© {new Date().getFullYear()} Education and Development Social Welfare Foundation. All rights reserved.</p>
          <p>Government Registered Trust • Digboi, Assam</p>
        </div>

        {affs.length > 0 && (
          <div className="mt-6 pt-6 border-t border-white/10" data-testid="footer-affiliations">
            <div className="flex flex-wrap items-center justify-center gap-6">
              <span className="text-[10px] uppercase tracking-widest text-stone-400">Affiliated With</span>
              {affs.map((a) => (
                <div key={a.id} className="flex items-center gap-2 bg-white/5 px-3 py-2 rounded-full" title={a.name}>
                  <img src={a.logo} alt={a.name} className="w-7 h-7 object-contain bg-white rounded-full p-0.5" />
                  <span className="text-[11px] font-semibold text-white">{a.short_name || a.name}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </footer>
  );
}
